import {
  Button,
  HeaderSearch as HeaderSearchComponent,
  HeaderSearchInputWrapper,
  InputField,
} from '@presentation/components';
import type { ArticleListPageFormValues } from '@presentation/pages';
import { useTranslation } from '@presentation/utils';
import { Form, useFormikContext } from 'formik';
import type { FC } from 'react';
import { FaSearch } from 'react-icons/fa';
import headerImage from '../../assets/tipaw-blog-header.webp';

export const HeaderSearch: FC<unknown> = () => {
  const { submitForm } = useFormikContext<ArticleListPageFormValues>();
  const { translate } = useTranslation();

  return (
    <Form>
      <HeaderSearchComponent
        title={translate('articleList.cover.title')}
        subtitle={translate('articleList.cover.subtitle')}
        backgroundImage={headerImage}
        withOverlay
        style={{ minHeight: 400 }}
        childrenWrapperContainerProps={{ style: { maxWidth: 700 } }}
        titleColor="white"
      >
        <HeaderSearchInputWrapper>
          <InputField
            name="title"
            clearButton={{
              showOnNotEmpty: true,
              onClear: () => submitForm(),
            }}
            placeholder={translate('common.inputs.searchKeyName.placeholder')}
          />
        </HeaderSearchInputWrapper>
        <Button color="blue" type="submit" shrink>
          <FaSearch />
        </Button>
      </HeaderSearchComponent>
    </Form>
  );
};
